(ns metabase.legacy-mbql.schema.macros
  (:require-macros
   [metabase.legacy-mbql.schema.macros]))

(comment metabase.legacy-mbql.schema.macros/keep-me)
